import { useQuery } from 'react-query';
import { getApi } from '../../../../config/SwaggerApi';
import { configQueryReactSimpleRequest } from '../../../core/hooks/useCodeTables/config';



const asiteAsiteCustomAttributeTypesFn = () =>
    getApi().asite.asiteGetAsiteCustomAttributeTypesGet().then((response) => response.data);


const useAsiteCustomAttributeTypesQuery = () => {
    const asiteDocsQuery = useQuery(
        ['asite-document-types'],
        asiteAsiteCustomAttributeTypesFn,
        configQueryReactSimpleRequest,
    );
    return asiteDocsQuery;
};

export default useAsiteCustomAttributeTypesQuery;
